import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import FormList from "../../../MedicalReview/ReviewSettings/FormList";
import { usersOnboardingService } from "../../../../../APIServices/usersOnboarding";

const SendForMedicalReview = ({
  Show,
  Hide,
  Title,
  onMouseDown,
  tableRef,
  schemaId,
  subjectId,
  siteId
}) => {
  const [subjectMedicalReview, setSubjectMedicalReview] = useState("inactive");
  const [userList, setUserList] = useState([]);
  const [reviewerList, setReviewerList] = useState([]);
  const [reviewLoader, setReviewLoader] = useState(false);
  const [dueDate, setDueDate] = useState("");
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getNextDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  const getSubjectMedicalReviewStatus = async () => {
    let data = await studyMedicalReviewServices.getSubjectMedicalReviewStatus(studyId, siteId, subjectId, schemaId)
    setDueDate(data?.dueDate || getNextDate())
    setReviewerList(data?.reviewerList || [])
  }

  const getAssignedAppUser = async () => {
    let data = await usersOnboardingService.getAssignedAppUser(studyId, "edc")
    setUserList(data?.data || [])
  }

  const sendSubjectForMedicalReview = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to send for Medical review!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, send it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setReviewLoader(true);
        let userData = {}
        userData.studyId = studyId
        userData.siteId = siteId
        userData.subjectId = subjectId
        userData.schemaId = schemaId
        userData.reviewerList = reviewerList
        userData.dueDate = dueDate
        userData.mode = StudyMode
        let data = await studyMedicalReviewServices.sendSubjectForMedicalReview(userData);
        if (data?.statusCode === 200) {
          getSubjectMedicalReviewStatus();
        }
      }
      setReviewLoader(false);
    });
  };

  useEffect(() => {
    if (schemaId && subjectId) {
      getSubjectMedicalReviewStatus();
    }
  }, [schemaId, subjectId]);

  useEffect(() => {
    getAssignedAppUser()
    setDueDate(getNextDate())
  }, []);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label>Assign User</Form.Label>
          <Form.Select
            multiple
            value={reviewerList}
            onChange={(e) => {
              const values = Array.from(
                e.target.selectedOptions,
                (option) => option.value
              );

              setReviewerList(values);
            }}
          >
            <option value="">Select User</option>
            {userList?.map((item, index) => (
              <option key={index} value={item?.userId}>
                {item?.fullName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Due Date</Form.Label>
          <Form.Control
            type="date"
            value={dueDate}
            min={new Date().toISOString().split("T")[0]}
            onChange={(e) => setDueDate(e.target.value)}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 hstack gap-2 bg-light border-top shadow-sm justify-content-end">
        <button
          className={`updateProfile`}
          onClick={sendSubjectForMedicalReview}
          disabled={reviewLoader || !studyId || !schemaId || !subjectId || !siteId || reviewerList?.length === 0}
          style={{ fontSize: 12 }}
        >
          {reviewLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" />
              {subjectMedicalReview === "inactive" ? "Sending..." : "Unsending..."}
            </div>
          ) : (
            subjectMedicalReview === "inactive" ? "Send for Medical Review" : "Undo Send for Medical Review"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default SendForMedicalReview;
